module.exports = __webpack_public_path__ + "img/item_blue2.cdacec6a.png";